module.exports = __webpack_public_path__ + "img/chatinator.5b8f936c.png";